<template>
  <v-dialog
    v-model="dialog"
    max-width="750px"
  >
    <template v-slot:activator="{ on:dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            text
            icon
            color="warning"
            v-on="{ ...dialog, ...tooltip }"
          >
            <v-icon>
              mdi-history
            </v-icon>
          </v-btn>
        </template>
        <span>View Approval History</span>
      </v-tooltip>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      :loading="loading"
      color="hrissecondary"
      :title="requester.name + ' (' + claimRequest.reference_number +')'"
      :text="'Approval Histories for Claim Reference Number ' + claimRequest.reference_number"
      class="mb-0"
      max-height="900px"
    >
      <template>
        <v-container
          v-if="!loading"
        >
          <v-row no-gutters>
            <v-col 
              cols="12"
              class="ma-0"
            >
              <v-card
                class="mx-0 overflow"
                max-width="700"
                max-height="650px"
              >
                <v-card-text class="py-0">
                  <v-timeline
                    align-top
                    dense
                  >
                    <v-timeline-item
                      v-for="(item, index) in approvals"
                      :key="index"
                      :color="getColor(item.approval_status_type_id)"
                      small
                      :icon="getIcon(index, item.approval_status_type_id)"
                    >
                      <v-row
                        no-gutters
                      >
                        <v-col cols="2">
                          <strong>{{ $moment(item.created_at).format('YYYY-MM-DD hh:mm A') }}</strong>
                        </v-col>
                        <v-col>
                          <strong>{{ item.status.name }}</strong>
                          <div class="text-caption mb-2">
                            {{ getText(item, index) }}
                          </div>
                          <div
                            v-if="item.remark"
                            class="text-overline mb-2 red--text"
                          >
                            <div class="font-weight-bold">
                              Remark:
                            </div>
                            <span
                              v-html="item.remark.replace(/\n/g, '</br>')"
                            />
                          </div>
                        </v-col>
                      </v-row>
                    </v-timeline-item>
                  </v-timeline>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </material-card> 
  </v-dialog>
</template>

<script>
  export default {
    props: {
      claimRequest: {
        type: Object,
        required: true,
      },
      requester: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        loading: false,
        approvals: [],
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return 

        this.loadData()
      },
    },
    methods: {
      loadData () {
        this.loading = true

        this.$api.claimRequestApprovals().list(this.claimRequest.approval_request.id)
          .then(res => {
            this.approvals = _.orderBy(res.data, ['created_at'], ['desc'])

            this.loading = false
          })
      },
      getColor (status) {
        if (status === 500 || status === 300) {
          return 'red'
        } else if (status === 501) {
          return 'grey'
        } else if (status === 200 || status === 600) {
          return 'green'
        } else {
          return 'warning'
        }
      },
      getIcon (index, status) {
        if (index === 0 && status === 600) {
          return 'mdi-check'
        } else if (status === 500 || status === 501) {
          return 'mdi-minus-thick'
        } else if (index === 0) {
          return ''
        } else {
          return 'mdi-arrow-up-thin'
        }
      },
      getText (approval, index) {
        if (approval.approval_status_type_id === 500) {
          if (approval.on_behalf_approver_id) {
            const prevApproval = this.approvals[index + 1]
            return 'Rejected by ' + approval.created_by + ' on behalf of ' + prevApproval.approver.person.name + '.'
          } else {
            return 'The claim request has been rejected by ' + approval.approver.person.name + '.'
          }
        } else if (approval.approval_status_type_id === 501) {
          const msg = 'The claim request has been cancelled by ' + approval.approver.person.name

          if (this.claimRequest.employee_uid !== approval.approver_id) {
            return msg + ' on behalf of ' + this.claimRequest.employee.person.name + '.'
          } else {
            return msg + '.'
          }
        } else if (
          approval.approval_status_type_id === 201 || 
          approval.approval_status_type_id === 250 || 
          approval.approval_status_type_id === 260 || 
          approval.approval_status_type_id === 200 || 
          approval.approval_status_type_id === 270 || 
          approval.approval_status_type_id === 502
        ) {
          let action = 'approved'

          if (approval.approval_status_type_id === 270) {
            action = 'escalated'
          } else if (approval.approval_status_type_id === 502) {
            action = 'reverted'
          } else if (approval.workflowable.approving_verb) {
            action = approval.workflowable.approving_verb
          }
          
          if (approval.on_behalf_approver_id) {
            const prevApproval = this.approvals[index + 1]
            return 'The claim request has been ' + action + ' by ' + approval.created_by + ' on behalf of ' + prevApproval.approver.person.name + '.'
          } else {
            return 'The claim request has been ' + action + ' by ' + approval.created_by + '.'
          }
        } else if (approval.approval_status_type_id === 400) {
          return approval.status.name + '.'
        } else if (approval.approval_status_type_id === 600) {
          return 'Reimbursed.'
        } else if (approval.approval_status_type_id === 300) {
          if (approval.on_behalf_approver_id) {
            const prevApproval = this.approvals[index + 1]
            return 'Requested more by ' + approval.created_by + ' on behalf of ' + prevApproval.approver.person.name + '.'
          } else {
            return approval.approver.person.name + ' request more on the claim request.'
          }
        } else { // 100
          if (this.claimRequest.on_behalf_requester) {
            return this.claimRequest.on_behalf_requester.person.name + ' apply on behalf of ' + this.claimRequest.employee.person.name + '.'
          } else {
            return approval.created_by + ' submitted a claim request.'
          }
        }
      },
    },
  }
</script>

<style scoped>
  .font-16{
    font-size:16px;
  }
  .overflow {
    max-height:550px;
    overflow: auto;
  }
</style>
